import { bindable } from "aurelia";
import { initPopovers } from 'flowbite'

export class CreditsComponent {
  @bindable creditBalance: number;

  attached() {
    initPopovers();
  }
}